import React from 'react';
import PropTypes from 'prop-types';
import UserCardView from './UserCard-view';

const UserCard = ({user}) => {
  return (
    <UserCardView {...user}/>
  )
};

UserCard.propTypes = {
  user: PropTypes.object,
};

export default UserCard;
